module.exports = "Pickers are used to select one or more items, such as tags or files, from a large list.\n"